import React, { ReactNode } from 'react';
import { Typography } from '../Typography';
import { NoContentInnerWrapper, NoContentOuterWrapper } from './style';

interface NoContentProps {
    title: string;
    subtitle?: ReactNode;
}

const NoContent = ({ title, subtitle }: NoContentProps) => (
    <NoContentOuterWrapper>
        <NoContentInnerWrapper>
            <Typography variant='h5' align='center'>{title}</Typography>
            {subtitle}
        </NoContentInnerWrapper>
    </NoContentOuterWrapper>
);


export default NoContent;
